
import { isEmpty } from 'lodash';
import moment from 'moment';
import adsApi from '../../libs/ads-request/ads-api';
import login from '../../modules/auth/application/login';
import OrderNotFoundError from '../../modules/auth/domain/OrderNotFoundError';
import createAuthApiRepository from '../../modules/auth/infrastructure/AuthApiRepository';

export default {
  data() {
    return {
      email: '',
      error: null,
      isLoading: false,
    };
  },

  computed: {
    bannerColor() {
      if (this.error instanceof OrderNotFoundError) {
        return 'purple-custom';
      }

      return 'negative';
    },
  },

  methods: {
    saveTokenInSession(token, expiresIn) {
      this.$session.set('token', token);
      localStorage.setItem('token', token);
      this.$session.set('expire_date', moment().add(expiresIn, 'seconds').format('YYYY-MM-DD HH:mm'));
    },

    async login() {
      this.isLoading = true;

      try {
        const repository = createAuthApiRepository();
        const { token, expiresIn } = await login(repository, { email: this.email, order: this.$session.get('superOrderId') });
        this.saveTokenInSession(token, expiresIn);

        await this.getPreLoginInfo();
        await this.getLoginInfo();
      } catch (error) {
        this.error = error;
      }

      this.isLoading = false;
    },

    async getPreLoginInfo() {
      await adsApi.preLogin(this.email, this.$session.get('superOrderId'))
        .then((response) => {
          const { data } = response;

          this.showTutorial = data.tutorial;

          const brand = !isEmpty(data.brand)
            ? data.brand.toLowerCase()
            : process.env.VUE_APP_BRAND;

          this.$session.set('email', this.email);
          this.$session.set('brand', brand);
          this.$session.set('urlDealerPrivacy', data.urlDealerPrivacy);
          this.$session.set('privacy', data.privacy);
          this.$session.set('transferData', data.transferData);
          this.showNoticePrivacy = data.privacy;
          this.loaderHide();
        });
    },

    async getLoginInfo() {
      const ERROR_MESSAGE_LOGIN = 'Ocurrio un error, intenterlo mas tarde';
      await adsApi.login(this.email, this.$session.get('superOrderId'))
        .then((res) => {
          const response = res.data;
          const { data } = response;
          if (!response.success) {
            this.isErrorLogin = true;
            this.errorMessageLogin = response.errorDescription ?? ERROR_MESSAGE_LOGIN;
          } else if (data.orders.length === 0) {
            this.notFoundOrders = true;
            // TODO: Check if OrderNotFoundError can be used here
            throw new Error('No se encontraron ordenes');
          } else {
            this.getDataAdviser(data.orders);
            this.$session.set('orderId', data.superOrderId);
            this.$session.set('orderIdDMS', data.superOrderIdDMS);
            this.$session.set('showAdditionalBudgets', false);
            this.$session.set('showPreInvoice', false);
            this.$session.set('showActivitiesList', false);
            this.$session.set('dealerId', data.dealerId);
            localStorage.setItem('dealerId', data.dealerId);
            this.$session.set('dealerName', data.dealerName);
            this.$session.set('dealerAddress', data.dealerDireccion);
            this.$session.set('dealerCity', data.dealerCiudad);
            this.$session.set('dealerState', data.dealerEstado);
            this.$session.set('plates', data.plates);
            this.$session.set('model', data.model);
            this.$session.set('year', data.years);
            this.$session.set('customerName', data.customerName);
            this.$session.set('customerRFC', data.customerRFC);
            this.$session.set('customerPhone', data.customerPhone);
            this.$session.set('customerPhoneCode', data.customerPhoneCode);
            this.$session.set('customerAddress', data.customerAddress);
            this.$session.set('orderComments', data.orderComments);
            this.$session.set('receptionKilometers', data.receptionKilometers);
            this.$session.set('dealerIdExt', data.dealerIdExt);
            this.$session.set('customerIdDMS', data.customerIdDMS);
            this.$session.set('orders', data.orders);
            this.$session.set('showTutorial', this.showTutorial);
            this.$session.set('nameContact', data.nameContact);
            this.$session.set('cellphoneContact', data.cellphoneContact);
            this.$session.set('emailContact', data.emailContact);
            localStorage.setItem('parentSuperOrder', data.parentSuperOrderIdDMS);
            localStorage.setItem('parentSuperOrderId', data.parentSuperOrderId);
            localStorage.setItem('ordersLogin', JSON.stringify(data.orders));
            localStorage.setItem('orderIdDMS', data.orders[0].orderIdDMS);
            if (data.parentSuperOrderId !== null) {
              localStorage.setItem('isParentOrder', true);
            } else {
              localStorage.setItem('isParentOrder', false);
            }

            this.$session.set('orderStatus', data.superOrderStatus);
            this.$store.commit('SET_LAYOUT', this.getEnvironmentLayoutName());
            localStorage.setItem('originAuth', true);
            this.$router.push({ name: 'home' });
          }
        });
    },

    getDataAdviser(orders) {
      const orderReception = orders.filter((item) => item.orderAdviserName !== null
      && item.orderAdviserEmail !== null);
      this.$session.set('adviserName', orderReception.length > 0 ? orderReception[0].orderAdviserName : '');
      this.$session.set('adviserCellphone', orderReception.length > 0 ? orderReception[0].orderAdviserCellphone : '');
      this.$session.set('adviserEmail', orderReception.length > 0 ? orderReception[0].orderAdviserEmail : '');
      this.$session.set('observations', orderReception.length > 0 ? orderReception[0].orderObservations : '');
    },
  },
};
